import Vue from "../../js/project-vue.js";
import "../../js/page-console.js";
import ProjectUser from "../../js/project-user.js";
import Page from "./PageIndex.vue";

new Vue({
    render: h => h(Page),
    mixins: [ProjectUser]
}).$mount("#page");
